(() => {
  const handle = 'durable-cotton-rope-dog-toy-ball-for-teeth-cleaning-pet-supplies-small-pet-dogs-chew-toy-knot-ball-cat-and-dog-teething-rope';
  const variantOrder = ['B', 'A', 'C', 'D', 'E', 'F', 'G'];
  const firstProductImageIndex = 8;

  function syncCottonRopeMedia() {
    const picker = document.querySelector(`variant-picker[data-product-handle="${handle}"]`);
    const gallery = document.querySelector('media-gallery');
    const slideshow = gallery?.querySelector('slideshow-component');
    if (!picker || !slideshow || typeof slideshow.select !== 'function') return;

    const selected = picker.querySelector('input[type="radio"]:checked');
    const variantIndex = variantOrder.indexOf(selected?.value || '');
    if (variantIndex < 0) return;

    const legend = picker.querySelector('.variant-option legend');
    if (legend && legend.textContent.trim() === 'Color') legend.textContent = 'Style';

    requestAnimationFrame(() => {
      slideshow.select(firstProductImageIndex + variantIndex, undefined, { animate: false });
    });
  }

  function init() {
    customElements.whenDefined('slideshow-component').then(syncCottonRopeMedia);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('change', (event) => {
    if (event.target instanceof Element && event.target.closest(`variant-picker[data-product-handle="${handle}"]`)) {
      syncCottonRopeMedia();
    }
  });

  document.addEventListener('shopify:section:load', syncCottonRopeMedia);
})();
